import { render } from "./FabButton.vue?vue&type=template&id=85416072&ts=true"
import script from "./FabButton.ts?vue&type=script&lang=ts&external"
export * from "./FabButton.ts?vue&type=script&lang=ts&external"

import "./FabButton.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QFab from 'quasar/src/components/fab/QFab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFab,QIcon});
